import React from 'react';
import light from "assets/ngage-logo-light.svg";
import dark from "assets/ngage-logo-dark.svg";
import {concatenate} from "services/string";

enum Size {X_SMALL, SMALL, MEDIUM, LARGE, X_LARGE}

enum Color {LIGHT, DARK}

const sizeClasses: Record<Size, string> = {
    [Size.X_SMALL]: 'max-h-4',
    [Size.SMALL]: 'max-h-6',
    [Size.MEDIUM]: 'max-h-8',
    [Size.LARGE]: 'max-h-12',
    [Size.X_LARGE]: 'max-h-16',
}

const logoSources: Record<Color, string> = {
    [Color.LIGHT]: light,
    [Color.DARK]: dark
}

type LogoProps = {
    src?: string | null
    size: Size
    color: Color
    className?: string
    onLoad?: () => void
}

function Logo({src, size, color, className, onLoad}: LogoProps) {
    return (
        <img
          className={concatenate(className, "w-auto", sizeClasses[size])}
          src={src ?? logoSources[color]}
          alt="Operator Logo"
          onLoad={onLoad}
        />
    );
}

Logo.sizes = Size
Logo.colors = Color

Logo.defaultProps = {
    size: Size.LARGE,
    color: Color.DARK
}

export default Logo;